import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { DatePicker, Drawer } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import dayjs from "dayjs";
import { message } from "antd";
import DeleteModal1 from "../../../core/modals/deleteModal1";
import { getEmployees } from "../../../core/data/redux/employee/employeeAction";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { exportToCSV, exportToExcel, exportToPDF, } from "../../../core/common/GlobalFunctions/exportTableData";
import { fetchAllAssets, fetchAssetDetailsByAssetId, fetchAssetLog, fetchAssetSummary, } from "../../../core/data/redux/asset/asset/assetActions";
import { allocateAsset, deleteAllocation, fetchAllAllocations, updateAllocation, updateAllocationStatus, } from "../../../core/data/redux/asset/assetAllocation/assetAllocationActions";
import { Select } from "antd";
import { filterByStatus } from "../../../core/utils/filterActiveData";
import { formatDate } from "../../../core/utils/configFormatters";
import { useAppConfig } from "../../../customhooks/useAppConfig";
import { decryptData } from "../../../core/utils/encryptUtils";
import { fetchAllAssetRequests } from "../../../core/data/redux/asset/assetRequest/assetRequestAction";
import { fetchAllMaintenances } from "../../../core/data/redux/asset/assetMaintenanceAction/assetMaintenanceAction";

const AssetAllocation = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedStatus, setSelectedStatus] = useState("allocated");
  const [selectedSort, setSelectedSort] = useState<any>("");
  const [tableKey, setTableKey] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const [modalType, setModalType] = useState<"edit" | "create" | "">("");
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const { user } = useSelector((state: any) => state.auth);
  const { employees } = useSelector((state: any) => state.employee);
  const employeeData = employees ? employees : [];
  const { assetAllocations, loading } = useSelector((state: any) => state.asset.assetAllocation);
  const { assets } = useSelector((state: any) => state.asset.newAsset);
  const { assetDetails } = useSelector((state: any) => state.asset.newAsset);
  const { assetRequests = [] } = useSelector((state: any) => state.asset.assetRequest);
  const [filteredRequests, setFilteredRequests] = useState<any[]>([]);
  const { maintenances } = useSelector((state: any) => state.asset.assetMaintenance);
  const [errors, setErrors] = useState<Record<string, string>>({});

  // optional tiny helper
  const FieldError = ({ msg }: { msg?: string }) =>
    msg ? <div className="text-danger small mt-1">{msg}</div> : null;

  const activeAssets = filterByStatus(assets, "active", "status");
  const activeEmployee = filterByStatus(employeeData, "active", "employee_status");

  const [assetAllocationData, setAssetAllocationData] = useState<any>({
    asset_id: "",
    serial_number: "",
    employee_id: "",
    allocated_by: "",
    allocated_at: dayjs(),
    expected_return_date: dayjs(),
    actual_return_date: dayjs(),
    allocation_status: "allocated",
    remarks: "",
    RequestNumber: '',
  });

  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];

  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");
  const canExport =
    permissions.includes("Export") || permissions.includes("AllowAll");

  const resetForm = () => {
    setAssetAllocationData({
      asset_id: "",
      serial_number: "",
      employee_id: "",
      allocated_by: "",
      allocated_at: dayjs(),
      expected_return_date: dayjs(),
      actual_return_date: dayjs(),
      allocation_status: "allocated",
      remarks: "",
      RequestNumber: '',
    });
    setErrors({});
  };

  useEffect(() => {
    if (assetAllocationData.employee_id) {
      const assignedRequestNumbers = assetAllocations.map(
        (allocation: any) => allocation.RequestNumber
      );

      const approvedRequests = assetRequests.filter(
        (req: any) =>
          req.EmployeeId == assetAllocationData.employee_id &&
          req.AssetRequestStatus == "Approved" &&
          !assignedRequestNumbers.includes(req.RequestNumber)
      );
      setFilteredRequests(approvedRequests);
    } else {
      setFilteredRequests([]);
    }
  }, [assetAllocationData.employee_id, assetRequests, assetAllocations]);


  // const employeesWithApprovedRequests = useMemo(() => {
  //   const approvedEmployeeIds = new Set(
  //     assetRequests
  //       .filter((req: any) => req.AssetRequestStatus === "Approved")
  //       .map((req: any) => req.EmployeeId)
  //   );

  //   return activeEmployee.filter((emp: any) =>
  //     approvedEmployeeIds.has(emp.EmployeeID)
  //   );
  // }, [assetRequests, activeEmployee]);

  useEffect(() => {
    dispatch(fetchAllAssetRequests());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchAllAllocations());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchAllMaintenances());
  }, [dispatch]);

  useEffect(() => {
    if (assetAllocationData?.asset_id) {
      dispatch(
        fetchAssetDetailsByAssetId({ assetId: assetAllocationData?.asset_id })
      );
    }
    if (!assets.length) {
      dispatch(fetchAllAssets());
    }
    if (!employees.length) dispatch(getEmployees());
  }, [
    dispatch,
    assetAllocationData?.asset_id,
    assetAllocations.length,
    assets.length,
    employees.length,
  ]);

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };

  const showModal = (type: "edit" | "create") => {
    setModalType(type);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setModalType("");
    resetForm();
  };

  const handleEditProject = (record: any): void => {
    setSelectedRowData(record);
    setAssetAllocationData({
      asset_id: record.asset_id,
      serial_number: record.serial_number,
      employee_id: record.employee_id,
      allocated_by: record.allocated_by,
      allocated_at: record.allocated_at ? dayjs(record.allocated_at) : dayjs(),
      expected_return_date: record.expected_return_date ? dayjs(record.expected_return_date) : dayjs(),
      actual_return_date: record.actual_return_date ? dayjs(record.actual_return_date) : dayjs(),
      allocation_status: record.allocation_status || "allocated",
      remarks: record.remarks,
      RequestNumber: record.RequestNumber,
    });
    showModal("edit");
  };

  const handleInputChange = (e: any, field: string) => {
    const { value } = e.target;
    setAssetAllocationData((prev: any) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: "" }));
  };


  const validate = () => {
    const e: Record<string, string> = {};
    const f = assetAllocationData;

    // Requireds
    if (!f.asset_id) e.asset_id = "Asset is required.";
    if (!f.serial_number) e.serial_number = "Asset serial number is required.";
    if (!f.employee_id) e.employee_id = "Employee is required.";
    if (!f.allocated_by) e.allocated_by = "Allocated by is required.";
    if (!f.allocated_at) e.allocated_at = "Allocated date is required.";
    if (!f.expected_return_date) e.expected_return_date = "Expected return date is required.";
    if (
      f.expected_return_date &&
      f.allocated_at &&
      f.expected_return_date.isBefore(f.allocated_at, "day")
    ) {
      message.warning("Expected return date can’t be before allocated date.");
      return false;
    }
    if (
      f.actual_return_date &&
      f.allocated_at &&
      f.actual_return_date.isBefore(f.allocated_at, "day")
    ) {
      message.warning("Actual return date can’t be before allocated date.");
      return false;
    }
    setErrors(e);
    return Object.keys(e).length === 0;
  };
  const handleSubmit = async () => {
    if (!validate()) return;
    const updatedFormData = {
      ...assetAllocationData,
      RequestNumber: assetAllocationData.RequestNumber === "" ? null : assetAllocationData.RequestNumber,
      CreatedBy: modalType === "create" ? user.UserId : undefined,
      ModifiedBy: modalType === "edit" ? user.UserId : undefined,
    };
    try {
      let result;
      if (modalType === "create") {
        result = await dispatch(allocateAsset(updatedFormData)).unwrap();
      } else if (modalType === "edit") {
        if (selectedRowData) {
          result = await dispatch(
            updateAllocation({
              allocationId: selectedRowData.allocation_id,
              ...updatedFormData,
            })
          ).unwrap();
        }
      }
      if (result) {
        message.success(result.message);
        await dispatch(fetchAllAllocations());
        await dispatch(fetchAllAssets());
        await dispatch(fetchAssetSummary());
        await dispatch(fetchAssetLog())
        setTableKey((prevKey) => prevKey + 1);
        resetForm();
      } else {
        alert(result?.payload.error);
      }
      handleCancel();
    } catch (error) {
      message.error("An error occurred");
    }
  };

  const handleDeleteAssetAllocation = async (allocationId: number) => {
    try {
      const result = await dispatch(deleteAllocation(allocationId)).unwrap();
      if (result) {
        message.success(result.message);
        await dispatch(fetchAllAllocations());
        await dispatch(fetchAllAssets());
        await dispatch(fetchAssetSummary());
        await dispatch(fetchAssetLog())
        setTableKey((prevKey) => prevKey + 1);
        setIsDeleteModalVisible(false);
      }
    } catch (error) {
      message.error("Something went wrong");
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const data = assetAllocations ? assetAllocations : [];

  const exportAssetAllocation = data.map((item: any) => ({
    RequestNumber: item.RequestNumber,
    AssetName: item.AssetName,
    SerialNumber: item.serial_number,
    EmployeeName: item.EmployeeName,
    AllocatedAt: item.allocated_at ? new Date(item.allocated_at).toLocaleDateString() : "N/A",
    ExpectedReturnDate: item.expected_return_date ? new Date(item.expected_return_date).toLocaleDateString() : "N/A",
    ActualReturnDate: item.actual_return_date ? new Date(item.actual_return_date).toLocaleDateString() : "N/A",
    AllocationStatus: item.allocation_status,
    CreatedAt: item.CreatedAt ? new Date(item.CreatedAt).toLocaleDateString() : "N/A",
    ModifiedAt: item.ModifiedAt ? new Date(item.ModifiedAt).toLocaleDateString() : "N/A",
  }))

  const filteredData = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { allocation_status: selectedStatus }
        : {};
    return filterData(
      data || [],
      filters,
      "created_at",
      "created_at",
      selectedSort
    );
  }, [data, selectedStatus, selectedSort]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [selectedStatus, selectedSort, assetAllocations]);

  const config = useAppConfig();
  if (!config) return null;

  const columns = [
    {
      title: "ID",
      dataIndex: "allocation_id",
      render: (text: number, record: any) => (
        <div>{record.allocation_id}</div>
      ),
      sorter: (a: any, b: any) => a.allocation_id - b.allocation_id,
    },
    {
      title: "Asset Name",
      dataIndex: "AssetName",
      render: (text: string, record: any) => (
        <h6 className="fw-medium">
          <div>{record.AssetName}</div>
        </h6>
      ),
      sorter: (a: any, b: any) => a.AssetName.length - b.AssetName.length,
    },
    {
      title: "Asset Serial Number",
      dataIndex: "serial_number",
      sorter: (a: any, b: any) =>
        a.serial_number.length - b.serial_number.length,
    },
    {
      title: "Employee Name",
      dataIndex: "EmployeeName",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center ">
          <Link to="#" className="avatar avatar-md">
            <img
              src={
                record.EmployeePicture ??
                "https://cdn-icons-png.flaticon.com/512/149/149071.png"
              }
              alt="img"
              className="img-fluid rounded-circle"
            />
          </Link>
          <div className="ms-2">
            <h6 className="fw-normal">
              <Link to="#">{text}</Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.EmployeeName.length - b.EmployeeName.length,
    },

    {
      title: "Return Date",
      dataIndex: "actual_return_date",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) =>
        a.actual_return_date.length - b.actual_return_date.length,
    },
    {
      title: "EMP ID",
      dataIndex: "EmployeeNumber",
      sorter: (a: any, b: any) =>
        a.EmployeeNumber.length - b.EmployeeNumber.length,
    },
    {
      title: "Status",
      dataIndex: "allocation_status",
      render: (text: string, record: any, index: number) => {
        const handleStatusChange = async (value: string) => {
          const allocationId = record.allocation_id;
          const allocationStatus = value;
          const data = {
            allocation_status: allocationStatus,
            modified_by: user.UserId,
          };
          try {
            const result = await dispatch(
              updateAllocationStatus({ allocationId, ...data })
            );
            if (updateAllocationStatus.fulfilled.match(result)) {
              message.success("Status changes SuccessFully");
              await dispatch(fetchAllAllocations());
              await dispatch(fetchAllAssets());
              await dispatch(fetchAssetSummary());
              await dispatch(fetchAssetLog())
              setTableKey((prevKey: any) => prevKey + 1);
            } else {
              console.error("Failed to update allocation:", result.error);
            }
          } catch (error) {
            console.error("Error updating allocation:", error);
          }
        };
        return (
          <Select
            value={text}
            onChange={handleStatusChange}
            style={{ width: 120 }}
            size="small"
          >
            <Select.Option value="allocated">Allocated</Select.Option>
            <Select.Option value="returned">Returned</Select.Option>
            <Select.Option value="lost">Lost</Select.Option>
            <Select.Option value="damaged">Damaged</Select.Option>
            {/* <Select.Option value="unknown">Unknown</Select.Option> */}
          </Select>
        );
      },
    },

    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => {
        const isInactive = record.status === "inactive"; // Optional: adjust field if needed
        const isEditDisabled = !canEdit;
        const isDeleteDisabled = !canDelete || isInactive;

        return (
          <div className="action-icon d-inline-flex">
            {/* Edit Button */}
            <button
              className="me-2"
              onClick={() => {
                if (!isEditDisabled) {
                  showModal("edit");
                  handleEditProject(record);
                }
              }}
              disabled={isEditDisabled}
              style={{
                cursor: isEditDisabled ? "not-allowed" : "pointer",
                opacity: isEditDisabled ? 0.5 : 1,
              }}
              title={!canEdit ? "Permission Denied" : "Edit"}
            >
              <i className="ti ti-edit" />
            </button>

            {/* Delete Button */}
            <button
              onClick={() => {
                if (!isDeleteDisabled) {
                  setSelectedRowData(record);
                  setIsDeleteModalVisible(true);
                }
              }}
              className="me-2"
              disabled={isDeleteDisabled}
              style={{
                cursor: isDeleteDisabled ? "not-allowed" : "pointer",
                opacity: isDeleteDisabled ? 0.5 : 1,
              }}
              title={
                !canDelete
                  ? "Permission Denied"
                  : isInactive
                    ? "Inactive Record"
                    : "Delete"
              }
            >
              <i className="ti ti-trash" />
            </button>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Asset Allocation</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={all_routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Asset</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Asset Allocation
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                {/* <div className="me-2 mb-2">
                  <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
                    <Link
                      to={all_routes.assetallocationdetails}
                      className="btn btn-icon btn-sm active bg-primary text-white me-1"
                    >
                      <i className="ti ti-list-tree" />
                    </Link>
                    <Link to={all_routes.project} className="btn btn-icon btn-sm">
                      <i className="ti ti-layout-grid" />
                    </Link>
                  </div>
                </div> */}
                {canExport && (
                  <div className="me-2 mb-2">
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        <i className="ti ti-file-export me-1" />
                        Export
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-3">
                        <li>
                          <button
                            onClick={() =>
                              exportToCSV(exportAssetAllocation, "asset_allocation_details")
                            }
                            className="dropdown-item rounded-1"
                          >
                            <i className="ti ti-file-type-pdf me-1" />
                            Export as CSV
                          </button>
                        </li>
                        <li>
                          <button
                            onClick={() =>
                              exportToExcel(exportAssetAllocation, "asset_allocation_details")
                            }
                            className="dropdown-item rounded-1"
                          >
                            <i className="ti ti-file-type-xls me-1" />
                            Export as Excel{" "}
                          </button>
                        </li>
                        <li>
                          <button
                            onClick={() =>
                              exportToPDF(exportAssetAllocation, "asset_allocation_details")
                            }
                            className="dropdown-item rounded-1"
                          >
                            <i className="ti ti-file-type-xls me-1" />
                            Export as PDF{" "}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                {canAdd && (
                  <div className="mb-2">
                    <button
                      onClick={() => showModal("create")}
                      className="btn btn-primary d-flex align-items-center"
                    >
                      <i className="ti ti-circle-plus me-2" />
                      Allocate Asset
                    </button>
                  </div>
                )}
                <div className="ms-2 head-icons">
                  <CollapseHeader />
                </div>
              </div>
            </div>
            {/* /Breadcrumb */}
            {/* Project list */}
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <h5>Asset Allocated List</h5>
                <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  <div className="dropdown me-3">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      {selectedStatus
                        ? selectedStatus.charAt(0).toUpperCase() +
                        selectedStatus.slice(1)
                        : "Select Status"}
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          onClick={() => setSelectedStatus("All")}
                          className="dropdown-item rounded-1"
                        >
                          All
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          onClick={() => setSelectedStatus("returned")}
                          className="dropdown-item rounded-1"
                        >
                          Returned
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          onClick={() => setSelectedStatus("lost")}
                          className="dropdown-item rounded-1"
                        >
                          Lost
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          onClick={() => setSelectedStatus("allocated")}
                          className="dropdown-item rounded-1"
                        >
                          Allocated
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          onClick={() => setSelectedStatus("damaged")}
                          className="dropdown-item rounded-1"
                        >
                          Damaged
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      {selectedSort
                        ? `Sort By : ${selectedSort}`
                        : "Sort By : Last 7 Days"}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          onClick={() => setSelectedSort("Recently Added")}
                          className="dropdown-item rounded-1"
                        >
                          Recently Added
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          onClick={() => setSelectedSort("Ascending")}
                          className="dropdown-item rounded-1"
                        >
                          Ascending
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          onClick={() => setSelectedSort("Descending")}
                          className="dropdown-item rounded-1"
                        >
                          Descending
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          onClick={() => setSelectedSort("Last Month")}
                          className="dropdown-item rounded-1"
                        >
                          Last Month
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          onClick={() => setSelectedSort("Last 7 Days")}
                          className="dropdown-item rounded-1"
                        >
                          Last 7 Days
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="card-body p-0">
                <Table
                  key={tableKey}
                  dataSource={filteredData}
                  columns={columns}
                  Selection={false}
                />
              </div>
            </div>
            {/* / Project list  */}
          </div>
          <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
            <p className="mb-0">2024 - 2025© hrmtree.</p>
            <p>
              Developed By{" "}
              <Link to="#" className="text-primary">
                Leadchain Systems
              </Link>
            </p>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>

      {/* Add Project */}
      <Drawer
        title={
          modalType === "edit" ? "Edit Allocate Asset" : "Add Allocate Asset"
        }
        placement="right"
        width={700}
        onClose={() => {
          handleCancel();
          resetForm();
        }}
        visible={isModalVisible}
        style={{ marginTop: 50, paddingBottom: 50 }}
      >
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="modal-body">
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    Asset <span className="text-danger"> *</span>
                  </label>
                  <select
                    className="form-control"
                    value={assetAllocationData.asset_id}
                    onChange={(e) => handleInputChange(e, "asset_id")}
                    disabled={modalType === "edit"}
                  >
                    <option value="">Select Asset</option>
                    {[...activeAssets]
                      ?.sort((a: any, b: any) => a.AssetName.localeCompare(b.AssetName))
                      ?.map((asset: any) => (
                        <option key={asset.assetId} value={asset.assetId}>
                          {asset.AssetName}
                        </option>
                      ))}
                  </select>
                  <FieldError msg={errors.asset_id} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    Asset Serial Number <span className="text-danger"> *</span>
                  </label>
                  <select
                    className="form-control"
                    value={assetAllocationData.serial_number}
                    onChange={(e) => handleInputChange(e, "serial_number")}
                    disabled={modalType === "edit"}
                  >
                    <option value="">Select Asset Serial Number</option>

                    {modalType === "edit" &&
                      assetAllocationData.serial_number &&
                      !assetDetails.find(
                        (a: any) =>
                          a.SerialNumber === assetAllocationData.serial_number
                      ) && (
                        <option value={assetAllocationData.serial_number}>
                          {assetAllocationData.serial_number}
                        </option>
                      )}
                    {assetDetails
                      ?.filter((asset: any) => {
                        const isBlocked = maintenances.some((m: any) =>
                          m.asset_details_id === asset.asset_details_id &&
                          m.status !== "completed" &&
                          m.status !== "paid"
                        );
                        return !isBlocked;
                      })
                      .map((asset: any) => (
                        <option key={asset.asset_details_id} value={asset.SerialNumber}>
                          {asset.SerialNumber}
                        </option>
                      ))}

                  </select>
                  <FieldError msg={errors.serial_number} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    Employee <span className="text-danger"> *</span>
                  </label>
                  <select
                    className="form-control"
                    value={assetAllocationData.employee_id}
                    onChange={(e) => handleInputChange(e, "employee_id")}
                  >
                    <option value="">Select Employee</option>
                    {[...activeEmployee]
                      .sort((a: any, b: any) => a.Name.localeCompare(b.Name))
                      .map((employee: any) => (
                        <option
                          key={employee.EmployeeID}
                          value={employee.EmployeeID}
                        >
                          {employee.Name}
                        </option>
                      ))}
                  </select>
                  <FieldError msg={errors.employee_id} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    Request Number
                  </label>
                  <select
                    className="form-control"
                    value={assetAllocationData.RequestNumber}
                    onChange={(e) => handleInputChange(e, "RequestNumber")}
                  >
                    <option value="">Select Request Number</option>
                    {modalType === "edit" && assetAllocationData.RequestNumber &&
                      !filteredRequests.find((r) => r.RequestNumber === assetAllocationData.RequestNumber) && (
                        <option value={assetAllocationData.RequestNumber}>
                          {assetAllocationData.RequestNumber}
                        </option>
                      )}
                    {filteredRequests.map((request: any) => (
                      <option key={request.RequestNumber} value={request.RequestNumber}>
                        {request.RequestNumber || `Request #${request.Id}`}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Allocated By <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="form-control"
                        value={assetAllocationData.allocated_by}
                        onChange={(e) => handleInputChange(e, "allocated_by")}
                      >
                        <option value="">Select Employee</option>
                        {[...activeEmployee]
                          .sort((a: any, b: any) => a.Name.localeCompare(b.Name))
                          .map((employee: any) => (
                            <option
                              key={employee.EmployeeID}
                              value={employee.EmployeeID}
                            >
                              {employee.Name}
                            </option>
                          ))}
                      </select>
                      <FieldError msg={errors.allocated_by} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Allocated At <span className="text-danger"> *</span>
                      </label>
                      <div className="input-icon-end position-relative">
                        <DatePicker
                          className="form-control datetimepicker"
                          format="DD-MM-YYYY"
                          getPopupContainer={getModalContainer}
                          value={assetAllocationData.allocated_at}
                          onChange={(date) => {
                            setAssetAllocationData({
                              ...assetAllocationData,
                              allocated_at: date,
                            });
                            if (errors.allocated_at) {
                              setErrors((p) => ({ ...p, allocated_at: "" }));
                            }
                          }}

                          placeholder="DD-MM-YYYY"
                        />
                        <FieldError msg={errors.allocated_at} />
                        <span className="input-icon-addon">
                          <i className="ti ti-calendar text-gray-7" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Expected Return Date{" "}
                        <span className="text-danger"> *</span>
                      </label>
                      <div className="input-icon-end position-relative">
                        <DatePicker
                          className="form-control datetimepicker"
                          format="DD-MM-YYYY"
                          getPopupContainer={getModalContainer}
                          value={assetAllocationData.expected_return_date}
                          onChange={(date) => {
                            setAssetAllocationData({
                              ...assetAllocationData,
                              expected_return_date: date,
                            });
                            if (errors.expected_return_date) {
                              setErrors((p) => ({ ...p, expected_return_date: "" }));
                            }
                          }}
                          placeholder="DD-MM-YYYY"
                        />
                        <FieldError msg={errors.expected_return_date} /> 
                        <span className="input-icon-addon">
                          <i className="ti ti-calendar text-gray-7" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Actual Return Date{" "}
                        <span className="text-danger"> *</span>
                      </label>
                      <div className="input-icon-end position-relative">
                        <DatePicker
                          className="form-control datetimepicker"
                          format="DD-MM-YYYY"
                          getPopupContainer={getModalContainer}
                          value={assetAllocationData.actual_return_date}
                          onChange={(date) =>
                            setAssetAllocationData({
                              ...assetAllocationData,
                              actual_return_date: date,
                            })
                          }
                          placeholder="DD-MM-YYYY"
                        />
                        <FieldError msg={errors.actual_return_date} /> 
                        <span className="input-icon-addon">
                          <i className="ti ti-calendar text-gray-7" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Remarks </label>
                      <textarea
                        className="form-control"
                        value={assetAllocationData.remarks}
                        onChange={(e) => handleInputChange(e, "remarks")}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                className="btn btn-outline-light border me-2"
                onClick={() => {
                  handleCancel();
                  resetForm();
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                type="button"
                onClick={handleSubmit} disabled={loading}
              >{loading && <span className="spinner-border spinner-border-sm me-2" />}
                {modalType === "edit" ? "Update Allocation" : "Allocate Asset"}
              </button>
            </div>
          </div>
        </form>
      </Drawer>

      {/* /Add Project */}
      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() =>
          selectedRowData?.allocation_id &&
          handleDeleteAssetAllocation(selectedRowData.allocation_id)
        }
      />
    </>
  );
};

export default AssetAllocation;
